/// <amd-module name="Artifacts/Root/helpers/DependencyHelpers" />

import * as Constants from "Artifacts/Root/Constants";
import { loadNonNullData } from "Artifacts/Root/helpers/DataProviderHelpers";
import { packageDetails } from "Artifacts/Root/routing/Constants";
import { IDependency, IDependencyGroup } from "Artifacts/Root/types/IDependency";
// import * as Url_Helper from "Feed/Legacy/Helpers/UrlHelper";
import { PackageDependencyDetails } from "Artifacts/Root/types/PackageDependencyDetails";
import { PackageDependency } from "Artifacts/Root/web-apis/contracts/Feed";
import { generatePath } from "react-router-dom";
import { IVssPageContext } from "VSS/Platform/Context";

export class DependencyHelpers {
  public static async getDependenciesForPackageVersionAsync(
    pageContext: IVssPageContext,
    feedId: string,
    packageId: string,
    packageVersionId: string,
    protocolType: string,
    projectName?: string,
  ): Promise<PackageDependencyDetails[]> {
    const properties = {
      projectName,
      feedId,
      packageId,
      packageVersionId,
      protocolType,
    };

    // this package-dependencies-data-provider is registered in ms.azure-artifacts namespace
    // but the server-side is from the legacy code base, as is the PackageDependencyDetails
    // contract.  PackageDependencyDetails and underlying data-provider could be
    // refactored to reside in the new code base, but does not due to time constraints.
    const dependencyDetails = loadNonNullData<PackageDependencyDetails[]>(
      pageContext,
      "ms.azure-artifacts.package-dependencies-data-provider",
      properties,
      true /* ignoreCache */,
      Constants.CommonConstants.FeedServiceInstanceId,
    );
    return dependencyDetails;
  }

  public static groupDependencyDetails(
    pageContext: IVssPageContext,
    dependencies: PackageDependencyDetails[],
    feedName: string,
    protocolType: string,
  ): IDependencyGroup[] {
    const dependencyGroups: IDependencyGroup[] = [];

    if (dependencies) {
      for (const dependency of dependencies) {
        const index = dependencyGroups.findIndex((group: IDependencyGroup) => {
          return group.group === dependency.group;
        });

        if (index > -1) {
          dependencyGroups[index].dependencies.push(<IDependency>{
            name: dependency.packageName,
            versionRange: dependency.versionRange,
            link: generatePath(packageDetails, {
              feedIdentifier: feedName,
              packageName: dependency.packageName,
              protocol: protocolType,
            }),
            packageId: dependency.packageId,
            packageVersionId: dependency.packageVersionId,
            normalizedPackageName: dependency.normalizedPackageName,
            protocolType,
          });
        } else {
          dependencyGroups.push(<IDependencyGroup>{
            dependencies: [
              {
                name: dependency.packageName,
                versionRange: dependency.versionRange,
                link: generatePath(packageDetails, {
                  feedIdentifier: feedName,
                  packageName: dependency.packageName,
                  protocol: protocolType,
                }),
                packageId: dependency.packageId,
                packageVersionId: dependency.packageVersionId,
                normalizedPackageName: dependency.normalizedPackageName,
                protocolType,
              },
            ],
            group: dependency.group,
          });
        }
      }
    }

    return dependencyGroups;
  }

  public static groupDependencies(dependencies: PackageDependency[]): IDependencyGroup[] {
    const dependencyGroups: IDependencyGroup[] = [];

    if (dependencies) {
      for (const dependency of dependencies) {
        const index = dependencyGroups.findIndex((group: IDependencyGroup) => {
          return group.group === dependency.group;
        });

        if (index > -1) {
          dependencyGroups[index].dependencies.push(<IDependency>{
            name: dependency.packageName,
            versionRange: dependency.versionRange,
          });
        } else {
          dependencyGroups.push(<IDependencyGroup>{
            dependencies: [
              {
                name: dependency.packageName,
                versionRange: dependency.versionRange,
              },
            ],
            group: dependency.group,
          });
        }
      }
    }

    return dependencyGroups;
  }
}
